import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import dayjs from "dayjs";

/**
 * สร้างและส่งออกไฟล์ Excel ที่มีแค่คอลัมน์ "ลำดับ" และ "CONTNO"
 * @param {Array<object>} rawData - ข้อมูลรายการสัญญา (เช่น ข้อมูลที่คุณให้มา)
 */
export async function ExportSimpleContractList(rawData = []) {
  console.log("rawData", rawData);

  const workbook = new ExcelJS.Workbook();
  const ws = workbook.addWorksheet("ContractList");

  // 1. กำหนดหัวตาราง (Headers)
  ws.columns = [
    { header: "ลำดับ", key: "index", width: 10 },
    { header: "CONTNO", key: "contno", width: 30 },
  ];

  // กำหนดรูปแบบหัวตาราง
  ws.getRow(1).height = 20;
  ws.getRow(1).font = { bold: true, size: 14, name: "Angsana New" };
  ws.getRow(1).alignment = { horizontal: "center", vertical: "middle" };
  ws.getRow(1).eachCell((cell) => {
    cell.border = {
      top: { style: "thin" },
      left: { style: "thin" },
      bottom: { style: "thin" },
      right: { style: "thin" },
    };
    cell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FFE0E0E0" }, // สีเทาอ่อน
    };
  });

  // 2. ใส่ข้อมูล
  const data = Array.isArray(rawData) ? rawData : [];

  data.forEach((row, index) => {
    const rowIndex = index + 2; // เริ่มที่แถวที่ 2
    ws.addRow({
      index: index + 1, // ลำดับที่ 1, 2, 3...
      contno: row.CONTNO || "", // ใช้ฟิลด์ CONTNO จากข้อมูลตัวอย่าง
    });

    // กำหนดรูปแบบข้อมูล
    const r = ws.getRow(rowIndex);
    r.font = { name: "Angsana New", size: 14 };
    r.alignment = { vertical: "middle", horizontal: "center" };
    r.eachCell((cell) => {
      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      };
    });
  });

  // 3. สร้างไฟล์และดาวน์โหลด
  const buf = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buf], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  saveAs(blob, `ContractList_${dayjs().format("DD-MM-YYYY_HHmmss")}.xlsx`);
}
